export function isObject(object: unknown): object is Record<string, unknown> {
  return typeof object === 'object' && object?.constructor === Object;
}
